import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AUTH_FEATURE_KEY, AuthState, User } from './auth.reducer';

// Lookup the 'Auth' feature state managed by NgRx
const getAuthState = createFeatureSelector<AuthState>(AUTH_FEATURE_KEY);

const getLoaded = createSelector(
  getAuthState,
  (state: AuthState) => state.loaded
);

const getLoading = createSelector(
  getAuthState,
  (state: AuthState) => state.loading
);

const getError = createSelector(
  getAuthState,
  (state: AuthState) => state.error
);

const getUser = createSelector(
  getAuthState,
  getLoaded,
  (state: AuthState, isLoaded) => {
    return isLoaded ? state.user : undefined;
  }
);

const isAuthenticated = createSelector(
  getUser,
  (user: User) => !!user
);

export const authQuery = {
  getLoaded,
  getLoading,
  getError,
  getUser,
  isAuthenticated
};
